"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arta-terme": {
    "7260fec0": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "skipSearch": false
    }],
    "chiarso": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f99d523e": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "skipSearch": false
    }],
    "d-inquam": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33afc28b": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "skipSearch": false
    }],
    "rinch": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c2bab8fd": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "skipSearch": false
    }],
    "rosa-dei-venti": [{
      "hkey": "32d97c03",
      "slug": "arta-terme",
      "name": "Arta Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;